<template>
  <spring-spinner :style="styleSpiner" :color="$themes.primary" v-if="isLoading" />
  <va-card :title="$t('publications.singleTitle') + publication.id" v-else-if="publication.id">
    <ul>
      <li class="cover_photos">
        <span>{{ $t('publications.single.cover_photos') }}:</span>
        <img v-for="photo in publication.cover_photos" :key="photo.id" :src="photo.file" />
      </li>
      <li>
        <span>{{ $t('publications.single.title') }}:</span>
        {{ publication.title }}
      </li>
      <li>
        <span>{{ $t('publications.single.lenderName') }}:</span>
        <router-link
          :style="{ color: 'var(--va-primary)' }"
          :to="{ name: 'user-single', params: { id: publication.lender.id } }"
        >{{ publication.lender.first_name }}</router-link>
      </li>
      <li>
        <span>{{ $t('publications.single.lenderlastName') }}:</span>
        <router-link
          :style="{ color: 'var(--va-primary)' }"
          :to="{ name: 'user-single', params: { id: publication.lender.id } }"
        >{{ publication.lender.last_name }}</router-link>
      </li>
      <li>
        <span>{{ $t('publications.single.category') }}:</span>
        <router-link
          :style="{ color: 'var(--va-primary)' }"
          :to="{ name: 'categoriesSingle', params: { id: publication.category.id } }"
        >{{ publication.category.name }}</router-link>
      </li>
      <li>
        <span>{{ $t('publications.single.rental_price') }}:</span>
        {{ publication.rental_price }}$
      </li>
      <li>
        <span>{{ $t('publications.single.discount_price') }}:</span>
        {{ publication.discount_price }}$
      </li>
      <li>
        <span>{{ $t('publications.single.bls_charge') }}:</span>
        {{ publication.bls_charge }}$
      </li>
      <li>
        <span>{{ $t('publications.single.from_n_days') }}:</span>
        {{ publication.from_n_days }}
      </li>
      <li>
        <span>{{ $t('publications.single.pickup_drop') }}:</span>
        {{ publication.pickup_drop }}
      </li>
      <li>
        <span>{{ $t('publications.single.item_upon_return') }}:</span>
        {{ publication.item_upon_return }}
      </li>
      <li>
        <span>{{ $t('publications.single.city') }}:</span>
        {{ publication.location }}
      </li>
      <!-- <li>
        <span>{{ $t('publications.single.is_archived') }}:</span>
        {{ publication.is_archived ? "✔️" : "❌" }}
      </li> -->
      <li>
        <span>{{ $t('publications.single.created_at') }}:</span>
        {{ moment(publication.created_at).format('LLL') }}
      </li>
      <li>
        <span>{{ $t('publications.single.updated_at') }}:</span>
        {{ moment(publication.updated_at).format('LLL') }}
      </li>
      <li>
        <span>{{ $t('publications.single.description') }}:</span>
        {{ publication.description }}
      </li>
      <li>
        <va-button
          color="danger"
          @click="deleteItem(publication.id)"
        >{{ $t('publications.delete') }}</va-button>
      </li>
    </ul>
  </va-card>
  <va-card v-else>
    <p class="display-1 text-center">{{ publication.detail }}</p>
  </va-card>
</template>
<script>
import { mapActions } from 'vuex'
import { SpringSpinner } from 'epic-spinners'
import moment from 'moment'

export default {
  data() {
    return {
      isLoading: true,
      publication: {},
    }
  },
  computed: {
    styleSpiner() {
      return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      }
    },
  },
  components: { SpringSpinner },
  methods: {
    moment,
    ...mapActions('Publications', ['getSingle', 'delete']),
    async deleteItem(id) {
      this.isLoading = true
      await this.delete(id)
      this.$router.push({ name: 'publications' })
    },
  },
  async created() {
    const response = await this.getSingle(this.$route.params.id)

    if (response.status === 404) {
      this.$router.push({ name: 'publications' })
    }

    this.publication = response.data
    this.isLoading = false
  },
}
</script>
<style lang="scss" scoped>
ul {
  li {
    font-size: 20px;

    span {
      font-weight: 600;
    }

    img {
      max-width: 200px;
      display: block;
    }

    &.cover_photos {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;

      span {
        flex-basis: 100%;
      }

      img {
        margin: 5px;
      }
    }
  }
}
</style>
